import React from "react";

const Checklist = ({ items }) => (
  <ul className="provider-beta__checklist">
    {items.map((item) => (
      <li key={item}>
        <span className="provider-beta__check" aria-hidden="true">
          ✓
        </span>
        {item}
      </li>
    ))}
  </ul>
);

export default Checklist;
